import React, {forwardRef} from 'react';
import './index.css';

const Input = forwardRef(function MyInput(props, ref) {

    const {type, className, ...other} = props;

    return (
        <input className={`form-control${className ? ' ' + className : ''}`} type={type ? type : 'text'} {...other} ref={ref} />
    );
});

export default Input;
